import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import { cButton } from '../creator/cGameObjects/cButton';
import { addCoinAnimation } from '../creator/cDisplayObjects/EvaluationCard';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { net } from '../creator/utils/net';


export class gameQuizDisplay extends cDisplay {


  private ccList: number[]

  private quizData: any = [];
  private quizText: any = {};

  // private questions: string[];
  // private answer_1: string[];
  // private answer_2: string[];
  // private answer_3: string[];
  // private answer_4: string[];
  // private correct: string[];

  private answers: number[]
  private coins: number = 0
  private correctCount: number = 0;
  private coinRef: any[]

  init(){
    super.init()
    this.coinRef = [];
    this.resetQuiz()
    addCoinAnimation(this.scene as cScene);


    //tasks
    (this.scene as cScene).ev.addListener('action',(command,options)=>{
      switch (options.command ){
        case 'next_opinion':
          this.nextQuestion();
          break;
        case 'correct':
          this.appendCoin();
          this.correctCount++;
          //setTimeout(()=>this.appendCoin(),400 )
          this.answers[ 10-this.ccList.length  ] = 1
          this.nextQuestion();
          break;
        case 'false':
          this.answers[ 10-this.ccList.length  ] = -1
          this.nextQuestion();
          break;
        case 'coin':
          this.appendCoin();
          break;
        case 'reset_game':
          this.resetQuiz();
          var tg: Phaser.GameObjects.Container = this.getByName('quiz_holder');          
          this.coinRef.forEach( el=>{ el.destroy()})
          this.coinRef = []
          this.nextQuestion();
          break;
      }
    })    
    
  }

  
  resetQuiz(){
    this.ccList = Phaser.Math.RND.shuffle([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]).slice(0,10);
    this.answers = new Array(0,0,0,0,0,0,0,0,0,0);
    this.coins = 0;
    this.correctCount = 0;

  }


  buildScene(){
    super.buildScene();

    setTimeout(()=>{
      var data_qu = this.getByName('DATA');
      var data = JSON.parse(data_qu.itemData.objectdata )
      this.quizData = data.list
      this.quizText = data.text
      this.nextQuestion();
    },1)
  }

  appendCoin(){
    var yy: number = this.coins * 10;
    var sp: Phaser.GameObjects.Sprite = new Phaser.GameObjects.Sprite(this.scene,1500,750-yy,'quiz_coins');
    sp.play('coin_drop')
    sp.depth = 999
    this.scene.add.existing(sp);
    this.coinRef.push(sp);
    var tg: Phaser.GameObjects.Container = this.getByName('quiz_holder');
    tg.add(sp);
    this.coins ++;
  }

  parseScore(st){
    st = st.replace('[count]',this.correctCount);
    return st;
  }

  nextQuestion(){
    if (this.ccList.length === 0){
      let coins = cGame.current.state.get('coins',0)
      if (coins === 0){
        cGame.current.state.set('coins',coins);
      }
      if (this.correctCount < 4){
        (this.scene as cScene).triggerSceneEvent('retry',{
          result_header: this.quizText.retry_header,
          result_text: this.quizText.retry_text,
          result_score: this.parseScore(this.quizText.retry_score),
          result_btn: this.quizText.retry_btn
        });
      }else{
        (this.scene as cScene).triggerSceneEvent('completed',{
          result_header: this.quizText.correct_header,
          result_text: this.quizText.correct_text,
          result_score: this.parseScore(this.quizText.correct_score),
          result_btn: this.quizText.correct_btn
        });
      }
    }else{
      var cur = this.ccList.pop();
      var left = 10 - this.ccList.length;
      var payload = {
        question: this.quizData[ cur ].question,
        answer_1: this.quizData[ cur ].answer1,
        answer_2: this.quizData[ cur ].answer2,
        answer_3: this.quizData[ cur ].answer3,
        answer_4: this.quizData[ cur ].answer4,
        correct:  this.quizData[ cur ].correct,
        counter: 'Frage '+left+' von 10'
      };
      
      (this.scene as cScene).triggerSceneEvent('next_quiz', payload);
      this.loadImage(cur+3);  
    }
  }


  loadImage(curIndex){
    var path = '/quiz/quiz_' + (( curIndex < 10 ) ? '0'+curIndex : ''+curIndex) + '.png';
    var img = new Image(100,100);
    img.addEventListener('load',()=>{      
      this.scene.textures.remove('quiz_current_page');
      this.scene.textures.addImage('quiz_current_page', img);
      (this.scene as cScene).getByName('quiz_image').setTexture('quiz_current_page');
    });
    img.crossOrigin = "Anonymous";
    img.src = net.serverUrl+path;
  }

}
